<template>
  <div :class="`mobileBack ${type}`">
    <div class="backIcon" @click="clickBack"></div>
  </div>
</template>

<script>

export default {
  data() {
    return {
    };
  },
  props: ['type', 'otherClick'],
  methods: {
    clickBack() {
      if (this.otherClick) return this.$emit('backOtherClick')
      if (window.history.length <= 1) {
        let query = this.$route.query
        return this.$router.push({path: `/ticket/home`, query:{museumCode : query.museumCode, code: query.code, id: query.id}})
      }
      history.go(-1)
    }
  },

  created() {
    
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
.mobileBack{
  padding-top: 0.2rem;
  .backIcon{
    width: 0.68rem;
    height: 0.68rem;
    margin: 0.3rem;
    margin-left: 0.5rem;
    background: url('../../assets/ticket/back-b.png') 0 0/contain no-repeat;
  }
  &.white{
    position: fixed;
    // top: 0.2rem;
    left: 0rem;
    .backIcon{
      background: url('../../assets/ticket/back-w.png') 0 0/contain no-repeat;
    }
  }
}
</style>
